import React from "react";
import CommonTitle from "@/components/common/CommonTitle";
import CommonSubtitle from "@/components/common/CommonSubtitle";

export interface SmartChatSectionProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
export interface SmartChatProps {
  title: string;
  subtitle?: string;
  featureArray: SmartChatSectionProps[];
}

const SmartChat = ({ title, subtitle, featureArray }: SmartChatProps) => {
  return (
    <div className="container py-8 xl:py-12">
      <div className="mx-auto">
        <div className="mx-auto space-y-4 pb-5 xl:px-20 xl:pb-16">
          <div className="mx-auto text-center sm:max-w-[900px] xl:max-w-[1180px]">
            <CommonTitle
              color="#202020"
              fontWeightClass="font-semibold"
              fontSizeClass="text-[26px] xl:text-[28px]"
            >
              {title}
            </CommonTitle>
          </div>
          <div className="mx-auto text-center sm:max-w-[900px] xl:max-w-[1180px]">
            {subtitle && (
              <CommonSubtitle
              >
                {subtitle}
              </CommonSubtitle>
            )}
          </div>
        </div>
        <div className="mx-auto">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            {featureArray.map((feature, index) => (
              <div
                key={index}
                className="relative rounded-[8px] bg-gradient-to-b from-[#F4F1FF] to-white"
              >
                <div className="h-full overflow-hidden rounded-[8px]">
                  <div className="flex h-full flex-col gap-5 rounded-lg p-6 xl:min-h-[120px] xl:justify-between xl:gap-2">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#F8F8F8] text-[#313131] text-[24px] font-semibold">
                      {index + 1}
                    </div>
                    <div className="flex flex-col gap-2">
                      <h3 className="text-[18px] lg:text-[20px] font-semibold text-[#202020]">
                        {feature.title}
                      </h3>
                      <p className="text-[14px] font-normal text-[#202020] xl:text-[16px]">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartChat;
